export default {

  index() {
    function merchant_disable_ctrl() {
      if ($('#merchant_merchant').is(':checked')) {
        $('#store_link_informations_div').hide().children().attr('disabled', true);
        $('#from_id_div').show().children().attr('disabled', false);
        $('#store_fax_div').show().children().attr('disabled', false);
        $('#store_country_en_div').show().children().attr('disabled', false);
        $('#store_state_en_div').show().children().attr('disabled', false);
        $('#store_city_en_div').show().children().attr('disabled', false);
        $('#store_street_en_div').show().children().attr('disabled', false);
        $('#jcb-div').show().children().attr('disabled', false);
        $('#store_paypay_div').show().children().attr('disabled', false);
        $('#mcc-div').show().children().attr('disabled', false);
        $('#store_sbps_div').show().children().attr('disabled', false);
        $('#store_world_pay_div').show().children().attr('disabled', false);
        $('#store_examination_div').show().children().attr('disabled', false);
        $('#store_paylight_flag_div').show().children().attr('disabled', false);
        $('#store_building_div').show().children().attr('disabled', false);
        $('#documents_addressee_type_div').hide().children().attr('disabled', true);
        $('#device_no_div').hide().children().attr('disabled', true);
        $('#dental_examination_div').hide().children().attr('disabled', true);
        $('#store_tenant_application_div').show().children().attr('disabled', false);
        $('#dental_tenant_application_div').hide().children().attr('disabled', true);
        $('#dental_terminal_information_div').hide().children().attr('disabled', true);
        $('#store_ai_call_div').show().children().attr('disabled', false);
        $('#store_insight_div').show().children().attr('disabled', false);
        $('#store_platform_div').show().children().attr('disabled', false);
        $('#pl_products_div').show().children().attr('disabled', false);
        document.getElementById('opening_date').innerHTML = '店舗オープン日';
      }
      if ($('#merchant_dentist').is(':checked')) {
        $('#store_link_informations_div').show().children().attr('disabled', false);
        $('#from_id_div').hide().children().attr('disabled', true);
        $('#store_fax_div').hide().children().attr('disabled', true);
        $('#store_country_en_div').hide().children().attr('disabled', true);
        $('#store_state_en_div').hide().children().attr('disabled', true);
        $('#store_city_en_div').hide().children().attr('disabled', true);
        $('#store_street_en_div').hide().children().attr('disabled', true);
        $('#jcb-div').hide().children().attr('disabled', true);
        $('#store_paypay_div').hide().children().attr('disabled', true);
        $('#mcc-div').hide().children().attr('disabled', true);
        $('#store_sbps_div').hide().children().attr('disabled', true);
        $('#store_world_pay_div').hide().children().attr('disabled', true);
        $('#store_examination_div').hide().children().attr('disabled', true);
        $('#store_paylight_flag_div').hide().children().attr('disabled', true);
        $('#store_building_div').hide().children().attr('disabled', true);
        $('#documents_addressee_type_div').show().children().attr('disabled', false);
        $('#device_no_div').show().children().attr('disabled', false);
        $('#dental_examination_div').show().children().attr('disabled', false);
        $('#store_tenant_application_div').hide().children().attr('disabled', true);
        $('#dental_tenant_application_div').show().children().attr('disabled', false);
        $('#dental_terminal_information_div').show().children().attr('disabled', false);
        $('#store_ai_call_div').hide().children().attr('disabled', true);
        $('#store_insight_div').hide().children().attr('disabled', true);
        $('#store_platform_div').hide().children().attr('disabled', true);
        $('#pl_products_div').hide().children().attr('disabled', true);
        document.getElementById('opening_date').innerHTML = '店舗オープン（年/月）';
      }
    }

    function getOutputColumns() {
      return $('input[type="checkbox"]').not('input[type="checkbox"][name="statuses[]"]');
    }

    document.addEventListener('DOMContentLoaded', () => {
      merchant_disable_ctrl();
      $('input.merchant_type').on('change', function() {
        $('input.merchant_type').not(this).prop('checked', false);
        merchant_disable_ctrl();

        if ($('#merchant_dentist').is(':checked')) {
          getOutputColumns().prop('checked', false);
          $('#shop_shop_id').prop('checked', true);
          $('#shop_status').prop('checked', true);
          $('#shop_sub_status').prop('checked', true);
          $('#agency_name').prop('checked', true);
          $('#store_name').prop('checked', true);
          $('#store_state').prop('checked', true);
          $('#storeapplication_created_at').prop('checked', true);
        }
      });

      $('#select-all').on('click', function() {
        $('input[type="checkbox"]').prop('checked', true);
      });

      $('#deselect-all').on('click', function() {
        $('input[type="checkbox"]').prop('checked', false);
      });

      $('#select-jcb').on('click', function() {
        getOutputColumns().prop('checked', false);
        $('#shop_shop_id').prop('checked', true);
        $('#store_name').prop('checked', true);
        $('#store_name_kana').prop('checked', true);
        $('#store_name_en').prop('checked', true);
        $('#store_url').prop('checked', true);
        $('#store_tel').prop('checked', true);
        $('#store_zip_code').prop('checked', true);
        $('#store_state').prop('checked', true);
        $('#store_state_kana').prop('checked', true);
        $('#store_city').prop('checked', true);
        $('#store_city_kana').prop('checked', true);
        $('#store_street').prop('checked', true);
        $('#store_street_kana').prop('checked', true);
        $('#store_building').prop('checked', true);
        $('#store_building_kana').prop('checked', true);
        $('#corporation_name').prop('checked', true);
        $('#corporation_name_kana').prop('checked', true);
        $('#corporation_number').prop('checked', true);
        $('#corporation_tel').prop('checked', true);
        $('#corporation_zip_code').prop('checked', true);
        $('#corporation_state').prop('checked', true);
        $('#corporation_state_kana').prop('checked', true);
        $('#corporation_city').prop('checked', true);
        $('#corporation_city_kana').prop('checked', true);
        $('#corporation_street').prop('checked', true);
        $('#corporation_street_kana').prop('checked', true);
        $('#corporation_building').prop('checked', true);
        $('#corporation_building_kana').prop('checked', true);
        $('#representative_last_name').prop('checked', true);
        $('#representative_first_name').prop('checked', true);
        $('#representative_last_name_kana').prop('checked', true);
        $('#representative_first_name_kana').prop('checked', true);
        $('#representative_birthday').prop('checked', true);
        $('#representative_tel').prop('checked', true);
        $('#representative_zip_code').prop('checked', true);
        $('#representative_state').prop('checked', true);
        $('#representative_state_kana').prop('checked', true);
        $('#representative_city').prop('checked', true);
        $('#representative_city_kana').prop('checked', true);
        $('#representative_street').prop('checked', true);
        $('#representative_street_kana').prop('checked', true);
        $('#representative_building').prop('checked', true);
        $('#representative_building_kana').prop('checked', true);
        $('#examination_d2d').prop('checked', true);
        $('#examination_telemarketing').prop('checked', true);
        $('#examination_chain_sales').prop('checked', true);
        $('#examination_business_offer_attraction').prop('checked', true);
        $('#examination_specified_offer').prop('checked', true);
        $('#examination_keeping_card_info').prop('checked', true);
        $('#examination_no_card_info_date').prop('checked', true);
        $('#examination_pcidss_info').prop('checked', true);
        $('#examination_pcidss_date').prop('checked', true);
        $('#examination_device_ic_info').prop('checked', true);
        $('#examination_device_ic_date').prop('checked', true);
      });

      $('#select-wp').on('click', function() {
        getOutputColumns().prop('checked', false);
        // SCOショップID
        $('#shop_shop_id').prop('checked', true);
        // 店舗情報
        $('#small_industry_name').prop('checked', true);
        $('#small_industry_mcc_id').prop('checked', true);
        $('#mccs_code').prop('checked', true);
        $('#mccs_description').prop('checked', true);
        $('#store_opening_date').prop('checked', true);
        $('#store_name').prop('checked', true);
        $('#store_name_kana').prop('checked', true);
        $('#store_name_en').prop('checked', true);
        $('#store_email').prop('checked', true);
        $('#store_url').prop('checked', true);
        $('#store_country_tel_code').prop('checked', true);
        $('#store_tel').prop('checked', true);
        $('#store_fax').prop('checked', true);
        $('#store_zip_code').prop('checked', true);
        $('#store_country').prop('checked', true);
        $('#store_country_en').prop('checked', true);
        $('#store_state').prop('checked', true);
        $('#store_state_kana').prop('checked', true);
        $('#store_state_en').prop('checked', true);
        $('#store_city').prop('checked', true);
        $('#store_city_kana').prop('checked', true);
        $('#store_city_en').prop('checked', true);
        $('#store_street').prop('checked', true);
        $('#store_street_kana').prop('checked', true);
        $('#store_street_en').prop('checked', true);
        $('#store_building').prop('checked', true);
        $('#store_building_kana').prop('checked', true);
        $('#store_building_en').prop('checked', true);
        // 法人情報
        $('#corporation_name').prop('checked', true);
        $('#corporation_name_kana').prop('checked', true);
        $('#corporation_name_en').prop('checked', true);
        $('#corporation_establishment_date').prop('checked', true);
        $('#corporation_number').prop('checked', true);
        $('#corporation_country_tel_code').prop('checked', true);
        $('#corporation_tel').prop('checked', true);
        $('#corporation_zip_code').prop('checked', true);
        $('#corporation_country').prop('checked', true);
        $('#corporation_state').prop('checked', true);
        $('#corporation_state_kana').prop('checked', true);
        $('#corporation_city').prop('checked', true);
        $('#corporation_city_kana').prop('checked', true);
        $('#corporation_street').prop('checked', true);
        $('#corporation_street_kana').prop('checked', true);
        $('#corporation_building').prop('checked', true);
        $('#corporation_building_kana').prop('checked', true);
        // 代表者情報
        $('#representative_last_name').prop('checked', true);
        $('#representative_first_name').prop('checked', true);
        $('#representative_last_name_kana').prop('checked', true);
        $('#representative_first_name_kana').prop('checked', true);
        $('#representative_last_name_en').prop('checked', true);
        $('#representative_first_name_en').prop('checked', true);
        $('#representative_gender').prop('checked', true);
        $('#representative_birthday').prop('checked', true);
        $('#representative_country_tel_code').prop('checked', true);
        $('#representative_tel').prop('checked', true);
        $('#representative_email').prop('checked', true);
        $('#representative_country').prop('checked', true);
        $('#representative_country_en').prop('checked', true);
        $('#representative_zip_code').prop('checked', true);
        $('#representative_state').prop('checked', true);
        $('#representative_state_kana').prop('checked', true);
        $('#representative_state_en').prop('checked', true);
        $('#representative_city').prop('checked', true);
        $('#representative_city_kana').prop('checked', true);
        $('#representative_city_en').prop('checked', true);
        $('#representative_street').prop('checked', true);
        $('#representative_street_kana').prop('checked', true);
        $('#representative_street_en').prop('checked', true);
        $('#representative_building').prop('checked', true);
        $('#representative_building_kana').prop('checked', true);
        $('#representative_building_en').prop('checked', true);
        // 加盟店審査
        $('#examination_examinator').prop('checked', true);
        $('#examination_status').prop('checked', true);
        $('#examination_risk_level').prop('checked', true);
        $('#examination_jdm').prop('checked', true);
        $('#examination_jdm_application_date').prop('checked', true);
        $('#examination_csrs2').prop('checked', true);
        $('#examination_csrs2_application_date').prop('checked', true);
        $('#examination_settlement_service').prop('checked', true);
        $('#examination_debate_reason').prop('checked', true);
        $('#examination_created_at').prop('checked', true);
        $('#examination_updated_at').prop('checked', true);
        $('#examination_max_settlement_amount_per_month').prop('checked', true);
        $('#examination_average_settlement_amount_per_day').prop('checked', true);
        $('#examination_average_settlement_number_per_day').prop('checked', true);
        $('#examination_is_continuous_billing').prop('checked', true);
        $('#examination_same_holder_limit').prop('checked', true);
        $('#store_examination_div input[type="checkbox"]').prop('checked', true);
      });

      $('#select-cashless').on('click', function() {
        getOutputColumns().prop('checked', false);
        $('#shop_shop_id').prop('checked', true);
        $('#shop_status').prop('checked', true);
        $('#shop_sub_status').prop('checked', true);
        $('#agency_name').prop('checked', true);
        $('#store_name').prop('checked', true);
        $('#store_state').prop('checked', true);
        $('#storeapplication_created_at').prop('checked', true);
      });

    })

  }

}
